import { render, staticRenderFns } from "./OutstandingInvestments.vue?vue&type=template&id=a270b406&"
import script from "./OutstandingInvestments.vue?vue&type=script&lang=js&"
export * from "./OutstandingInvestments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports